import React, { PureComponent } from 'react';
import Input from 'components/ui/input';
import InputProps from 'components/ui/input/InputProps';
import Utils from 'helpers/Utils';

interface InputAmountProps extends InputProps {
  fractional?: number;
  allowNegative?: boolean;
}

class InputAmount extends PureComponent<InputAmountProps> {
  render() {
    const { allowNegative, ...rest } = this.props;
    return <Input {...rest} onChange={this.handleChange} />;
  }

  handleChange = (event) => {
    const { onChange, fractional = 2, allowNegative = true } = this.props;
    let value = event.target.value.replace(/ /gi, '');

    if (!allowNegative) {
      value = value.replace(/-/g, '');
    }

    const caret = event.target.selectionStart;
    const element = event.target;

    window.requestAnimationFrame(() => {
      if (value.length > caret) {
        element.selectionStart = caret;
        element.selectionEnd = caret;
      }
    });

    const signPattern = allowNegative ? '-?' : '';
    const regexPattern = fractional === 0
      ? new RegExp(`(^${signPattern}\\d+$)`)
      : new RegExp(`(^${signPattern}\\d+(\\.\\d{0,${fractional}})?$)`);

    const allowedValues = allowNegative ? ['', '-'] : [''];

    if (regexPattern.test(value) || allowedValues.includes(value)) {
      event.target.value = Utils.getNumberWithSpace(value);
      if (onChange) {
        onChange(event);
      }
    }
  };
}

export default InputAmount;
